import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\@babel\\runtime-corejs2/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    info: {
      type: Object,
      default: function _default() {}
    },
    jumpTo: {
      type: String,
      default: 'ticket'
    }
  },
  data: function data() {
    return {
      visible: false,
      checked: false
    };
  },
  methods: {
    open: function open() {
      this.visible = true;
      this.checked = false;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    toOrderPage: function toOrderPage(item) {
      if (!this.checked) return;
      this.$store.commit('setTicketInfo', _objectSpread({}, item));
      this.$router.push({
        name: this.jumpTo,
        params: {
          id: this.info.id
        }
      });
    }
  }
};